import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d5acde2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "emailtemplate" }
const _hoisted_2 = {
  class: "modal-title",
  id: "emailtemplate-modal-label"
}
const _hoisted_3 = { class: "report-items" }
const _hoisted_4 = {
  class: "nav nav-tabs mb-3",
  role: "tablist"
}
const _hoisted_5 = { class: "nav-item" }
const _hoisted_6 = {
  key: 0,
  class: "nav-item"
}
const _hoisted_7 = { class: "navbar fixed-bottom navbar-dark bg-primary" }
const _hoisted_8 = { class: "container-fluid" }
const _hoisted_9 = {
  id: "status-bar-actions",
  style: {"margin-left":"auto"}
}
const _hoisted_10 = { class: "text-light" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_13 = {
  class: "btn-group",
  role: "group",
  "aria-label": "Secondary Actions"
}
const _hoisted_14 = ["disabled"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-ban" }, null, -1))
const _hoisted_16 = {
  class: "btn-group",
  role: "group",
  "aria-label": "Primary Actions"
}
const _hoisted_17 = ["disabled"]
const _hoisted_18 = {
  key: 0,
  class: "spinner-border spinner-border-sm"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Loading...", -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = {
  key: 1,
  class: "fas fa-save"
}

import { computed, ref, onMounted, inject } from 'vue';
import { useStore } from 'vuex';
import { useRouter, useRoute } from 'vue-router';
import { useToast } from "vue-toastification";
import { EmailTemplate, Dictionary } from "@/models";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const store = useStore();
const router = useRouter();
const route = useRoute();
const toasted = useToast();
const actProperty: any = inject('actProperty');

// State
const isSaving = ref(false);

// Computed Properties
const hasUnsavedChanges = computed<boolean>(() => store.getters['emailtemplates/hasUnsavedChanges']);
const emailtemplate = computed<EmailTemplate>(() => store.getters['emailtemplates/current']);

// Methods
const setEmailTemplate = (emailtemplate: EmailTemplate): void => {
 store.commit('emailtemplates/setEmailTemplate', emailtemplate);
};

const getEmailTemplate = (id: string): Promise<any> => {
  return store.dispatch('emailtemplates/getEmailTemplate', id);
};

const addEmailTemplate = (emailtemplate: EmailTemplate): Promise<any> => {
  return store.dispatch('emailtemplates/addEmailTemplate', emailtemplate);
};

const updateEmailTemplate = (emailtemplate: EmailTemplate): Promise<any> => {
  return store.dispatch('emailtemplates/updateEmailTemplate', emailtemplate);
};

const resetUnsavedChanges = (): void => {
  store.commit('emailtemplates/resetUnsavedChanges');
};

const canSave = () => {
  const et = emailtemplate.value;
  return et && et.subject && et.body;
};

const save = () => {
  if (canSave()) {
    if (isNewTemplate()) {
     addEmailTemplate(emailtemplate.value).then(et => {
        toasted.success(`Saved new template`);
        router.push({ name: "emailtemplate", params: { id: et.id }});
      });
    } else {
     updateEmailTemplate(emailtemplate.value).then(() => {
        toasted.success(`Saved`);
        router.push({ name: "emailtemplates" });
      });
    }
  }
};

const isNewTemplate = () => {
  return (route.params.id as string) === "new";
};

const cancel = () => {
  resetUnsavedChanges();
  router.back();
};

onMounted(async () => {
  resetUnsavedChanges();
  if (isNewTemplate()) {
    setEmailTemplate(new EmailTemplate());
    return;
  }
  try {
    const et = await getEmailTemplate(route.params.id as string);
    if (et === undefined) {
      actProperty.displayError(`Could not find email template with ID ${route.params.id as string}`);
      router.push({ name: "emailtemplates" });
    }
  } catch (err) {
    actProperty.displayError(err);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, " Email template: " + _toDisplayString(emailtemplate.value.title), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("ul", _hoisted_4, [
        _createElementVNode("li", _hoisted_5, [
          _createVNode(_component_router_link, {
            to: { name: 'email-template-details'},
            class: "nav-link",
            "active-class": "active"
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Template ")
            ]),
            _: 1
          })
        ]),
        (!isNewTemplate() && !emailtemplate.value.defaulttemplate)
          ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
              _createVNode(_component_router_link, {
                to: {name: 'email-template-clients', params: {search: _unref(route).params.search || 'a'}},
                class: "nav-link",
                "active-class": "active"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Customers ")
                ]),
                _: 1
              }, 8, ["to"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_openBlock(), _createBlock(_component_router_view, {
      key: _ctx.$route.name,
      style: {"padding-bottom":"60px"}
    })),
    _createElementVNode("nav", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            (hasUnsavedChanges.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_11, "You have unsaved changes"))
              : (_openBlock(), _createElementBlock("span", _hoisted_12, "No unsaved changes")),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("button", {
                class: _normalizeClass(["btn btn-outline-light", { disabled: !hasUnsavedChanges.value }]),
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (cancel()), ["prevent"])),
                disabled: !hasUnsavedChanges.value
              }, [
                _hoisted_15,
                _createTextVNode(" Cancel ")
              ], 10, _hoisted_14)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("button", {
                class: _normalizeClass(["btn btn-light", { disabled: !hasUnsavedChanges.value }]),
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (save()), ["prevent"])),
                disabled: isSaving.value || !hasUnsavedChanges.value
              }, [
                (isSaving.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_18, _hoisted_20))
                  : (_openBlock(), _createElementBlock("i", _hoisted_21)),
                _createTextVNode(" Save ")
              ], 10, _hoisted_17)
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})